// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/offerfit/:app_group_id/use_cases/:use_case_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { offerfitAppGroupIdUseCasesUseCaseId } from "./constants";
import type { UseCaseEnvironment, OfferfitAppGroupIdUseCasesUseCaseIdResult } from "./types";
import { isOfferfitAppGroupIdUseCasesUseCaseIdResult } from "./validators";

export const getOfferfitAppGroupIdUseCasesUseCaseId = reactQueryFetcherAdapter(
  offerfitAppGroupIdUseCasesUseCaseId,
  (
    signal: AbortSignal,
    appGroupId: string,
    useCaseId: string,
    environment?: UseCaseEnvironment
  ): Promise<OfferfitAppGroupIdUseCasesUseCaseIdResult> => {
    return fetch(`/offerfit/${appGroupId}/use_cases/${useCaseId}`, "GET", { environment }, { signal });
  },
  isOfferfitAppGroupIdUseCasesUseCaseIdResult
);

/**
 * Wizard-only GET fetcher that suppresses the global error modal on expected 404s for draft agents.
 */
export const getOfferfitAppGroupIdUseCasesUseCaseIdForWizard = reactQueryFetcherAdapter(
  offerfitAppGroupIdUseCasesUseCaseId,
  (
    signal: AbortSignal,
    appGroupId: string,
    useCaseId: string,
    environment?: UseCaseEnvironment
  ): Promise<OfferfitAppGroupIdUseCasesUseCaseIdResult> => {
    return fetch(
      `/offerfit/${appGroupId}/use_cases/${useCaseId}`,
      "GET",
      { environment },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isOfferfitAppGroupIdUseCasesUseCaseIdResult
);
